import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import TransomConfigurator from './../TransomConfigurator'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView05ImageOptions } from './views/ExteriorView05'

class Xr41BathingLadder extends Component {
  constructor (props) {
    super(props)
    this.state = { overlayUrls: [] }
    this.handleBathingLadderChange = this.handleBathingLadderChange.bind(this)
    this.handleOverlayUrls = this.handleOverlayUrls.bind(this)
  }

  handleOverlayUrls (urls) {
    const current = this.state.overlayUrls
    if (urls.length !== current.length || urls.some((u, i) => u !== current[i])) {
      this.setState({ overlayUrls: urls })
    }
  }

  handleBathingLadderChange (newValue) {
    let configuration = this.props.configuration
    configuration.BathingLadder = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

	render() {
		let imageOptions = exteriorView05ImageOptions;

    let image = (
      <div style={{ position: 'relative' }}>
        <TransomConfigurator
          colorMultiplier={0.75}
          name={this.props.transom.Name}
          port={this.props.transom.Port}
          transomSize={{ width: 2222, height: 610 }}
          transform={[
            0.130899, 0.033411, 0, -4.1e-5,
            0.01831, 0.204526, 0, 8.7e-5,
            0, 0, 1, 0,
            167.111097, 331.423513, 0, 1
          ]}
        >
          <ConfiguratorImage
            boat='Xr41'
            configuration={this.props.configuration}
            options={imageOptions}
            onOverlayUrls={this.handleOverlayUrls}
          />
        </TransomConfigurator>
        {this.state.overlayUrls.length > 0 && (
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', pointerEvents: 'none', zIndex: 10 }}>
            {this.state.overlayUrls.map((url) => (
              <img key={url} src={url} alt='' style={{ position: 'absolute', top: 0, left: 0, width: '100%', objectFit: 'contain' }} />
            ))}
          </div>
        )}
      </div>
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Removable bathing ladder' />
          </h1>

          <p>
					<Trans defaults='The stainless steel bathing ladder is removable when racing or for ever better access in the harbour. ' />
          </p>

          <RadioGroup
            label={this.props.t('Options:')}
            options={this.props.bathingLadderOptions}
            value={this.props.configuration.BathingLadder}
            onChange={this.handleBathingLadderChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41BathingLadder)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41BathingLadder.js